import { useState, useEffect } from 'react';
import Toast from './Toast';

interface ToastItem {
  id: number;
  message: string;
  type?: 'success' | 'error' | 'info';
}

export default function ToastContainer() {
  const [toasts, setToasts] = useState<ToastItem[]>([]);

  useEffect(() => {
    const handler = (e: Event) => {
      const { message, type } = (e as CustomEvent).detail || {};
      if (!message) return;
      setToasts([{ id: Date.now(), message, type: type || 'success' }]);
    };
    window.addEventListener('showToast', handler);
    return () => window.removeEventListener('showToast', handler);
  }, []);

  if (toasts.length === 0) return null;

  return (
    <div className="fixed top-4 right-8 z-[9999] flex flex-col items-end">
      {toasts.map((t) => (
        <Toast key={t.id} id={t.id} message={t.message} type={t.type} onClose={(id) => setToasts((prev) => prev.filter((x) => x.id !== id))} />
      ))}
    </div>
  );
}
